import { createContext, useContext } from "react";
import { useNotifications } from "../hooks/useNotifications";
import { usePendingAccessRequests } from "../hooks/usePendingAccessRequests";
import { useDistrict } from "../lib/district-context";

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const { district, userProfile } = useDistrict();
  const isAdmin = userProfile?.role === "admin";

  const notifs = useNotifications(district?.id);
  const { count: pendingAccessRequestsCount, requests: pendingAccessRequests } = usePendingAccessRequests(isAdmin);

  return (
    <NotificationsContext.Provider value={{ ...notifs, pendingAccessRequestsCount, pendingAccessRequests }}>
      {children}
    </NotificationsContext.Provider>
  );
}

const EMPTY = {
  unreadCount: 0,
  notifications: [],
  loading: false,
  markRead: () => {},
  dismissAll: () => {},
  clear: () => {},
  reload: () => {},
  refresh: () => {},
  pendingAccessRequestsCount: 0,
  pendingAccessRequests: [],
};

export const useNotificationsCtx = () => useContext(NotificationsContext) ?? EMPTY;
